









import { Component, Prop, Vue } from 'vue-property-decorator';

import Login from './Login.vue';
import Customer from '@/app/features/Customer/Customer.vue';

@Component({
  components: {
    Login,
    Customer,
  },
})
export default class LoginDashboard extends Vue {
  @Prop({ default: true }) private readonly showRegister: boolean;
}
